
//# sourceMappingURL=/s/files/1/0402/0210/9079/t/6/assets/custom.js.map?v=1628815185

// Infinite Options by ShopPad
// This theme removes event handlers attached to the add to cart button when the variant changes
// Reinit Infinite Options to reattach event handlers
document.addEventListener('variant:changed', function(event) {
  window.Shoppad.apps.infiniteoptions.init();
});